// extracted by mini-css-extract-plugin
export var copyableField = "_qa-4";
export var customerBadge = "_qa-0";
export var customerInfoTitle = "_qa-2";
export var details = "_qa-1";
export var dropdownContainer = "_qa-5";
export var dropdownImage = "_qa-6";
export var editAssigneeForm = "_qa-a";
export var editButton = "_qa-3";
export var email = "_qa-7";
export var hidden = "_qa-d";
export var input = "_qa-8";
export var saveButton = "_qa-b";
export var shopifyIcon = "_qa-c";
export var suggestionBadge = "_qa-e";
export var suggestionText = "_qa-f";
export var username = "_qa-9";